import React from 'react';
import { Card } from 'antd';
import { useSelector } from 'react-redux';
import { CloseCircleOutlined, LockOutlined } from '@ant-design/icons';

const XShieldWrapper = ({ children }) => {
  const store = useSelector((state) => state?.company?.store);
  const hasAccess = store?.features?.includes('XShield');

  if (!hasAccess) {
    return (
      <>
        {children}
        <div className='absolute inset-0 z-50 flex items-center justify-center w-full h-full select-none'>
          <div
            style={{
              textAlign: 'center',
              padding: '40px',
              borderRadius: '12px',
              backgroundColor: 'rgb(0 0 0 / 18%)',
              backdropFilter: 'blur(12px)',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            }}>
            <div
              className='error-icon'
              style={{
                width: '80px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
              }}>
              <CloseCircleOutlined
                style={{
                  fontSize: '40px',
                  color: 'red',
                }}
              />
            </div>

            <h2
              style={{
                color: '#000000',
                fontSize: '28px',
                marginBottom: '16px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}>
              <LockOutlined style={{ fontSize: '20px' }} />
              Access Required
            </h2>

            <p
              style={{
                color: '#000000',
                fontSize: '16px',
                lineHeight: '1.6',
                marginBottom: '24px',
                padding: '0 20px',
              }}>
              You don't have access to use XShield. Please contact XPay support team to get access.
            </p>
          </div>
        </div>
      </>
    );
  }

  return children;
};

export default XShieldWrapper;